<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">Juramentación</span></h3>
          </v-card-title>
          <v-card-text>
                <!-- direccion subject -->
                <v-flex xs12 align-center justify-space-between>
                  <v-layout align-center>
                    <v-flex xs12 md4>
                      <v-text-field
                        ref="cpc"
                        v-model="form.cpc"
                        prepend-icon="credit_card"
                        label="CPC"
                        rows="1"
                        :rules="[v => !!v || 'CPC es requerido']"
                        :error-messages="errCpc"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md8>
                      <v-text-field
                        disabled
                        ref="name"
                        prepend-icon="person"
                        v-model="form.name"
                        :rules="[v => !!v || 'Nombre y Apellido es requerido']"
                        label="Nombre y Apellido"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 align-center justify-space-between>
                  <v-layout align-center>
                    <v-flex xs12 md6>
                      <v-menu
                        ref="menu"
                        lazy
                        :close-on-content-click="false"
                        v-model="menu"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        min-width="290px"
                        :return-value.sync="form.start"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha de Juramentación"
                          v-model="computedDateFormattedFecha"
                          hint="DD/MM/YYYY formato"
                          prepend-icon="event"
                          :rules="[v => !!v || 'Fecha de Juramentación es requerida']"
                          required
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="form.start" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.menu.save(form.start)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-select
                            :items="sworn_place"
                            ref="sworn_place"
                            prepend-icon="add_location"
                            v-model="form.sworn_place"
                            label="Tipo"
                            :rules="[v => !!v || 'Tipo de juramentación es requerido']"
                            required
                        ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 align-center justify-space-between>
                    <p style="text-align: center;">Datos del libro de actas</p>
                  <v-layout align-center>
                    <v-flex xs12 md6>
                      <v-menu
                        ref="menu2"
                        lazy
                        :close-on-content-click="false"
                        v-model="menu2"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        min-width="290px"
                        :return-value.sync="form.fecha_resolucion"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha del Acta"
                          v-model="computedDateFormattedFecha2"
                          hint="DD/MM/YYYY formato"
                          prepend-icon="event"
                          :rules="[v => !!v || 'Fecha del acta es requerida']"
                          required
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="form.fecha_resolucion" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.menu2.save(form.fecha_resolucion)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-text-field
                            ref="resolucion"
                            prepend-icon="featured_play_list"
                            v-model="form.resolucion"
                            label="Libro y Folio"
                            :rules="[v => !!v || 'Libro y Folio es requerido']"
                            required
                        ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
            
                <v-select
                    ref="condition"
                    :items="condition"
                    v-model="form.condition"
                    @change="changeCondition"
                    label="Estatus"
                    prepend-icon="featured_play_list"
                    :rules="[v => !!v || 'Estatus es requerido']"
                ></v-select>

                <v-autocomplete
                    v-if="form.condition == 'INCORPORADO'"
                    ref="old_college_id"
                    prepend-icon="school"
                    item-text="name"
                    item-value="id"
                    :items="colleges"
                    v-model="form.old_college_id"
                    label="Colegio Anterior"
                    :rules="[v => !!v || 'Colegio Anterior es requerido']"
                    required
                ></v-autocomplete>

                <input hidden type="file" ref="fileInput" @change="processFile($event)">
                <v-text-field
                    v-if="form.condition == 'INCORPORADO'"
                    ref="old_document"
                    v-model="form.old_document"
                    @click.native="onFocus"
                    prepend-icon="attach_file"
                    label="Solicitud de incorporacion"
                ></v-text-field>

          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" class="primary" @click="submit">Juramentar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'form-user-view',

  props: {
    item: {
        type: Object,
        required: true
    },
    colleges: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  watch: {
    item(v) {
        this.$refs.form.resetValidation()
        this.form.id = v.id
        this.form.name = v.name
    }
  },

  computed: {

    ...mapGetters({
      authenticated: 'authCheck'
    }),

    computedDateFormattedFecha () {
      return this.formatDate(this.form.start)
    },

    computedDateFormattedFecha2 () {
      return this.formatDate(this.form.fecha_resolucion)
    }

  },

  data: () => ({
    items: [],
    errCpc: [],
    errTitle: [],
    nacionality: ['V','E','P'],
    sworn_place: ['ACTO', 'SECRETARIA'],
    condition: ['ACTIVO', 'INCORPORADO'],
    valid: false,
    traslado: false,
    date: null,
    menu: false,
    menu2: false,
    form: new Form({
      name: '',
      start: '',
      resolucion: '',
      condition: 'ACTIVO',
      fecha_resolucion: '',
      sworn_place: 'ACTO',
      old_college_id: '',
      old_document: '',
      file: null,
      cpc: ''
    }),
    formOld:{
      name: '',
      start: '',
      resolucion: '',
      condition: 'ACTIVO',
      fecha_resolucion: '',
      sworn_place: 'ACTO',
      old_college_id: '',
      old_document: '',
      file: null,
      cpc: ''
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    changeCondition () {
        if (this.form.condition == 'ACTIVO') {
            this.form.old_college_id = ''
            this.form.old_document = ''
        }
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('loadingResponse', true)
        this.submitFormJuramentado()
      }
    },

    async submitFormJuramentado () {
        this.$emit('loadingResponse', true)
        let formData = new FormData();
        for (var key in this.form) {
          formData.append(key, this.form[key]);
        }

        try {
            const { data } = await axios.post('/api/users/admin/juramentar-agremiado', formData)
            this.cerrarDialog(data)
        } catch (e) {
            console.log(e.response, 'data error create')
            this.$emit('loadingResponse', false)
            if (e.response.data.errors) {
                this.form.errors.errors = e.response.data.errors
                if (e.response.data.errors.cpc) {
                    this.$refs.cpc.focus()
                    this.errCpc.push('Cpc ya existe')
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: e.response.data.errors.cpc[0]
                    })
                }
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: e.response.data.error
                })
            }
        }

    },

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },


    cerrarDialog (data) {
      this.$emit('closeDialogJuramentacion', data)
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
        this.$emit('loadingResponse', false)
     })
    },

    onFocus() {
        this.$refs.fileInput.value = ''
        this.$refs.fileInput.click()
    },

    processFile(event) {
      let files = event.target.files || event.dataTransfer.files
      if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg") {
        this.form.file = files[0]
        this.form.old_document = files[0].name
      }else {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'El formato del documento debe ser PNG/JPG/JPEG'
        })
      }
    },

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/formJuramentacion.vue